import React from 'react';
import { classnames, getInitials } from 'helpers/utils';
import styles from './avatar-stack.module.scss';

type AvatarStackProps = {
  names: string[];
};

const AvatarStack: React.FC<AvatarStackProps> = ({ names }) => {
  const visibleNames = names.slice(0, 4);

  const avatarColors = ['#ebf5fa', '#ebf4f3', '#fcf4ea', '#faf7e9'];

  return (
    <div className={styles.avatarStack}>
      {visibleNames.map((name, index) => (
        <div
          key={name}
          className={classnames(
            styles.avatar,
            'text__body__regular__large__info60',
          )}
          style={{
            zIndex: visibleNames.length - index,
            backgroundColor:
              index === 0
                ? avatarColors[index % avatarColors.length]
                : avatarColors[index % avatarColors.length],
          }}
        >
          {index === 0 ? getInitials(name) : null}
        </div>
      ))}
    </div>
  );
};

export { AvatarStack };
